import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import JobProfileDetailsAccordions from "#job-profile/components/job-profile-details/JobProfileDetailsAccordions"
import JobProfileDetailsFooter from "#job-profile/components/job-profile-details/JobProfileDetailsFooter"
import JobProfileDetailsGenerals from "#job-profile/components/job-profile-details/JobProfileDetailsGenerals"
import JobProfileDetailsHeader from "#job-profile/components/job-profile-details/JobProfileDetailsHeader"
import { UseJobProfileDetailsContexts } from "#job-profile/contexts/JobProfileDetailsContexts"
import { jobProfileIdGet } from "#job-profile/services/api"
import { Box, Skeleton } from "@mui/material"
import { useEffect, useMemo } from "react"

export default function JobProfileDetails({ id }) {
	const { setJobProfile, reload } = UseJobProfileDetailsContexts()
	const params = useMemo(() => ({ id }), [id])
	/**
	 * @type {{ data: JobProfileType | null }}
	 */
	const { data, error, loading, fetch } = useApi(jobProfileIdGet, {
		autoFetch: !!id,
		params,
		reload,
	})

	useEffect(() => {
		setJobProfile(data ? data : null)
	}, [data, setJobProfile])

	if (loading) return <Skeleton variant="rectangular" width={"100%"} height={"90vh"} />
	if (error) return <ErrorResponse height="80vh" api={error} />

	return (
		<Box height={"100%"} sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
			<JobProfileDetailsHeader />
			<JobProfileDetailsGenerals />
			<JobProfileDetailsAccordions id={id} />
			<JobProfileDetailsFooter />
		</Box>
	)
}
